

export const events = {
  1: "cl_lnd_cd4_look_for_sign",
  2: "cl_lnd_cd4_welcome_sign",
  3: "cl_lnd_cd4_first_ques_sign",
  4: "cl_lnd_cd4_sec_ques_sign",
  5: "cl_lnd_cd4_third_ques_sign",
  6: "cl_lnd_cd4_fourth_ques_sign",
  7: "cl_lnd_cd4_fifth_ques_sign",
  8: "cl_lnd_cd4_sixth_ques_sign",
  9: "cl_lnd_cd4_sev_ques_sign",
  10: "cl_lnd_cd4_well_done_sign",
  11: "cl_lnd_cd4_i_am_sign",
  12: "cl_lnd_cd4_name_sign",
  13: "cl_lnd_cd4_date_birth_sign",
  14: "cl_lnd_cd4_email_sign",
  15: "cl_lnd_cd4_password_sign",
};

export const consentPropertyType = "site_consent";
export const cookieConsentPropertyType = "CookieConsent";

export const errorEventsName = {
  empty: "err_lnd_name_noname",
  too_short: "err_lnd_name_shortname",
  invalid_chars: "err_lnd_name_symbolname",
};

export const errorEventsBirthday = {
  M: "err_lnd_age_onlymonth",
  D: "err_lnd_age_onlyday",
  Y: "err_lnd_age_onlyyear",
  MD: "err_lnd_age_onlydaymonth",
  DY: "err_lnd_age_onlydayyear",
  MY: "err_lnd_age_onlymonthyear",
};

export const errorEventsEmail = {
  "This field cannot be empty.": "err_lnd_email_noemail",
  "Please enter a correct email address.": "err_lnd_email_wrongemail",
};

export const errorEventsPassword = {
  empty: "err_lnd_password_nopassword",
  too_short: "err_lnd_password_shortpassword",
};

export const ERROR_EMAIL_ALREADY_USED =
  "This email address has already been used.";

export const IS_VISIBLE_CUSTOM_AUTOCOMPLETE = false;

export const domains = [
  "@gmail.com",
  "@yahoo.com",
  "@hotmail.com",
  "@aol.com",
  "@outlook.com",
  "@comcast.net",
  "@live.com",
  "@mail.com",
  "@msn.com",
  "@att.net",
  "@icloud.com",
];


export const AppreciatePeople = [
  "Open-mindedness",
  "A good sense of humor",
  "Supportiveness",
  "Empathy and understanding",
];

export const Lifestyle = [
  "Outdoorsy, adventurous",
  "Cozy, introverted",
  "Social, vibrant",
  "Minimalist living",
  "Creative, artistic",
];

export const InterestedIn = [
  "Having Fun",
  "Flirty Talk",
  "Befriending",
  "Cozy Chatting",
];



export const Question7 = [
  { id: "9", label: "Serious relationship", event: "cl_lnd_sev_ques_serious" },
  { id: "10", label: "Casual chats", event: "cl_lnd_sev_ques_casual" },
  { id: "11", label: "Friendship", event: "cl_lnd_sev_ques_friendship" },
  { id: "12", label: "Open to various connections", event: "cl_lnd_sev_ques_open" },
]

export const landingId = "c4d3aa35a91f07d97b987d1c97a4925d";


